
import apiRequest from "./apiRequest";

export const directAndKmpApi = {

    fetchDirectAndKmpRegister: (accountId, token) => {
    return apiRequest(`/api/register/director-and-kmp/account?accountId=${accountId}`, 'GET', token);
  },
  

  // Submit MGT-1 form data
  submitDirectorAndKmForm: (formData, accountId, token) => {
    return apiRequest(`/api/register/director-and-kmp?accountId=${accountId}`, 'POST', token, formData);
  },

     addNewDirANdKmpEntry: (id, payload, token) => {
        return apiRequest(
          `/api/register/director-and-kmp/add-new/${id}`,
          "POST",
          token,
          payload          // ← body is forwarded as-is to apiRequest
        );
      },

    

 

  
};